import React, { useState, useEffect } from 'react'
import Logo from '../Logo';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Dropdown from '../UI/Dropdown';
import { ReactComponent as LogoIcon } from '../../assets/icons/logo.svg';
import classes from './index.module.scss';
import { ReactComponent as SearchIcon } from '../../assets/icons/search-input-icon.svg';

const HEADER_SEARCH_DROPDOWN_ITEMS = [
  {
    name: "Contract Opportunities",
    link: "/search?entity=contract_opportunities"
  },
  {
    name: "B2B Opportunities",
    link: "/search?entity=b2b_opportunities"
  },
  {
    name: "Future Opportunities",
    link: "/search?entity=future_opportunities"
  },
  {
    name: "Businesses",
    link: "/search?entity=businesses"
  },
  {
    name: "Micro Purchases",
    link: "/search?entity=micro_purchases"
  }
];

const HEADER_REGISTER_DROPDOWN_ITEMS = [
  {
    name: "Business",
    link: "/registration-preview"
  },
  {
    name: "Government Agency",
    link: "/registration?role=officer"
  }
];

const LogoutHeader = () => {
  const [showMobileMenuButton, setShowMobileMenuButton] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);


  useEffect(() => {
    if(window.screen.width <= 575) {
      setShowMobileMenuButton(true);
    }
  }, [showMobileMenuButton])

  return (
    <header className={classes.Header}>
      <Container>
        <Row>
          <Col className={classes.Header_Col}>
              <Logo
                path="/"
              >
                <LogoIcon/>
              </Logo>
              { ((window.screen.width <= 575 && showMobileMenu) || window.screen.width > 575) && 
                <div className={classes.Main_Nav}>
                <Link
                  to="/"
                  className="defaultBtn outlineBtn"
                >
                  Home
                </Link>
                <Dropdown 
                  title="Register"
                  dropDownList={HEADER_REGISTER_DROPDOWN_ITEMS}
                  className="outlineBtn"
                />
                <Dropdown 
                  title="Search"
                  icon={<SearchIcon />}
                  dropDownList={HEADER_SEARCH_DROPDOWN_ITEMS}
                  className="outlineBtn"
                />
                </div>
              }
            <div className={classes.Sign_In_Button}>
              <Link className="btnSizes transparentBtn outlineBtn" to="/sign-in">Sign In</Link>
            </div>
            { showMobileMenuButton && 
              <div className={classes.Main_Nav_Mobile_Button} onClick={() => setShowMobileMenu(!showMobileMenu)}>
                <span className={classes.Main_Nav_Mobile_Icon}>&#9776;</span>
              </div>
            }
          </Col>
        </Row>
      </Container>
    </header>
  )
}

export default LogoutHeader;